import { Injectable } from "@angular/core";

import {

  HttpErrorResponse,

  HttpEvent,

  HttpHandler,

  HttpInterceptor,

  HttpRequest,

  HttpResponse,

} from "@angular/common/http";

import { Router } from "@angular/router";

import { Observable, throwError } from "rxjs";

import { TokenService } from "./Services/token.service";

import { catchError, map } from "rxjs/operators";

import { AuthService } from "./Services/auth.service";

import { ToastrService } from "ngx-toastr";

import { EventEmitterService } from "./Services/event-emitter.service";

import { FlowServiceService } from "./Services/flow-service.service";
import { getAccessContextHeaders } from "./shared/utils/device-access.util";



@Injectable()

export class AuthInterceptor implements HttpInterceptor {

  constructor(

    private router: Router,

    private tokenService: TokenService,

    private authService: AuthService,

    private toast: ToastrService,

    private eventService: EventEmitterService,

    private flowService: FlowServiceService

  ) {}



  intercept(request: HttpRequest<any>, next: HttpHandler): any {

    const token = this.tokenService.getToken();



    if (this.hasUsableToken(token) && this.shouldAttachAuthHeader(request.url)) {

      request = request.clone({

        setHeaders: {

          Authorization: "Bearer " + token,

        },

      });

    }

    if (this.shouldAttachAccessContext(request.url)) {
      const accessHeaders = getAccessContextHeaders();
      request = request.clone({
        setHeaders: accessHeaders,
      });
    }



    return next.handle(request).pipe(

      map((event: HttpEvent<any>) => {

        if (event instanceof HttpResponse) {

          return event;

        }

        return event;

      }),

      catchError((error: HttpErrorResponse) => {

        if (

          error.status === 401 &&

          this.shouldHandleSessionExpiry(request.url)

        ) {

          this.eventService.setLoggedInUserProperty(false);

          this.handleUnauthorizedError();

        }

        return throwError(() => error);

      })

    );

  }



  private isSessionExpired = false;



  private hasUsableToken(token: string | null): token is string {

    if (!token) return false;

    const normalized = token.trim().toLowerCase();

    return normalized !== "" && normalized !== "null" && normalized !== "undefined";

  }



  private shouldAttachAuthHeader(url: string): boolean {

    const loweredUrl = (url || "").toLowerCase();

    const blockedHosts = [

      "blob.core.windows.net",

      "googleapis.com",

      "gstatic.com",

      "google.com/recaptcha",

      "translate.google.com",

      "googletagmanager.com",

    ];



    return !blockedHosts.some((host) => loweredUrl.includes(host));

  }



  private shouldAttachAccessContext(url: string): boolean {

    return this.shouldAttachAuthHeader(url);

  }



  private shouldHandleSessionExpiry(url: string): boolean {

    if (!this.tokenService.hasUsableToken()) {

      return false;

    }

    const loweredUrl = (url || "").toLowerCase();

    return !loweredUrl.includes("/authentication/login");

  }



  private handleUnauthorizedError() {

    if (!this.isSessionExpired) {

      this.isSessionExpired = true;

      this.toast.error("Please sign in again as your session expired");

      this.tokenService.clearAuthStorage();

      this.router.navigate(["/"]).then(() => {

        // Keep flag set until next successful login.

      });

    }

  }

}

